import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

const getPath = (id: number) => `/courses/${id}`

export type GetCoursesById = {
  id: number
  name: string
  line_url?: string
  line_qr_image_url?: string
  description?: string
}

export const fetchGetCoursesById = defineFetcher((id: number): Promise<GetCoursesById> => {
  return GET(getPath(id))
})
